export default "/images/bb95a4479cee6fb4ac67df95a536f797.png";